'use strict';

intellidealerAppCoreModule.factory('customerARAgenciesResource', function ($resource, appConfigurationService) {
  return {
    assignedPaymentAgencies: $resource(appConfigurationService.basePath + '/rest/customeraragencies/assignedPaymentAgencies/')
  };
});
